import React from 'react';

const styles = {
  container: {
    width: '100%',
    margin: '0 auto',
    padding: '16px',
  },
  title: {
    fontSize: '24px',
    fontWeight: 'bold',
    marginBottom: '16px',
  },
  address: {
    fontSize: '16px',
    lineHeight: '1.8',
    whiteSpace: 'pre-line',
  },
};

const ShowroomAdress = ({ title = 'ショールーム住所', address }) => {
  if (!address) return null;

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>{title}</h1>
      <p style={styles.address}>{address}</p>
    </div>
  );
};

export default ShowroomAdress;
